export { default } from "./NoImageIcon";
